export const headerViewHeight = 36;
